module.exports = __webpack_public_path__ + "static/media/Warning.3ea1d15f.svg";